<div class="mb-3" *ngFor="let option of options; let i = index" [ngClass]="{ 'option-card': option.type === 'paper' }">
  <div *ngIf="option.type === 'paper'" class="option-label flex flex-row items-center justify-between">
    <span class="option-name"
      >{{ option.name }}
      <span *ngIf="option.id === 'paperColor'">: {{ selectedColor }}</span>
    </span>
    <ion-icon *ngIf="option.id === 'paperWeight' || option.id === 'paperSize'" src="assets/icon/info.svg"></ion-icon>
  </div>

  <div
    *ngIf="option.type === 'paper'"
    class="selection-group flex flex-row flex-wrap gap-2"
    [ngClass]="{ pending: option.pending }"
  >
    <div
      class="selection"
      [ngClass]="{
        'w-full': option.id === 'paperPattern',
        'flex-1': option.id !== 'paperPattern' && option.id !== 'paperColor',
        'flex-none basis-0': option.id === 'paperColor',
      }"
      *ngFor="let value of option.values; let j = index"
    >
      <input
        id="{{ option.name }}-{{ j }}"
        [name]="option.name"
        type="radio"
        [value]="value"
        (ngModelChange)="onChange(option, i, value)"
        [disabled]="option.pending"
        [(ngModel)]="optionsSelected[option.id]"
        [ngClass]="{ 'paper-color-input': option.id === 'paperColor' }"
      />

      <div *ngIf="!option.imgPath" class="selector flex flex-row" (click)="clickInput(option.name + '-' + j, i)">
        <label
          *ngIf="option.id !== 'paperColor' && option.id !== 'paperPattern'"
          for="{{ option.name }}-{{ j }}"
          [ngClass]="{ disabledOption: !option.pending && isDisabled(option, value.value) }"
          class="flex flex-col items-center justify-center"
          >{{ value.name }}

          <span *ngIf="option.id === 'paperWeight' && value.name === '80 g'">Un folio de toda la vida</span>
          <span *ngIf="option.id === 'paperWeight' && value.name === '100 g'">Un poco más grueso</span>
          <span *ngIf="option.id === 'paperWeight' && value.name === '300 g'">Tipo cartulina del cole</span>

          <span *ngIf="option.id === 'paperSize' && value.name === 'A4'">21x29.7cm</span>
          <span *ngIf="option.id === 'paperSize' && value.name === 'A5'">14.8x21cm</span>
        </label>

        <label
          *ngIf="option.id === 'paperColor'"
          for="{{ option.name }}-{{ j }}"
          [ngClass]="{ disabledOption: !option.pending && isDisabled(option, value.value) }"
          class="cuadro-color flex flex-col items-center justify-center"
          [ngStyle]="{ 'background-color': value.data.color }"
        >
        </label>

        <label
          *ngIf="option.id === 'paperPattern'"
          for="{{ option.name }}-{{ j }}"
          [ngClass]="{ disabledOption: !option.pending && isDisabled(option, value.value) }"
          class="pattern-selector flex flex-row items-center justify-start gap-2.5"
        >
          <img
            [src]="'assets/images/paper-patterns/' + value.value.toLowerCase() + '.svg'"
            [alt]="value.name"
            class="pattern-icon"
          />
          <div>{{ value.name }}</div>
        </label>
      </div>
    </div>
  </div>
</div>

<div class="option-card mb-20" *ngIf="optionsHaveBinding()">
  <div class="row binding-option flex">
    <img src="assets/images/finishings/encuadernado.svg" alt="" />
    <div class="ml-4 flex flex-col">
      <span class="option-name"> Encuadernado</span>
      <span class="option-subtitle">Espiral y tapas</span>
    </div>
  </div>
  <ion-segment [value]="segmentBinding" (ionChange)="onSegmentChange($event, 'binding')">
    <ion-segment-button class="custom-segment-button" value="rings">
      <ion-label>Anillas</ion-label>
    </ion-segment-button>
    <ion-segment-button class="custom-segment-button" value="coverFront">
      <ion-label>Tapa delantera</ion-label>
    </ion-segment-button>
    <ion-segment-button class="custom-segment-button" value="coverBack">
      <ion-label>Tapa trasera</ion-label>
    </ion-segment-button>
  </ion-segment>
  <div class="binding-options-body">
    <div class="segment-selection">
      <span>Color escogido: {{ utils.getColorName(optionsSelected[segmentBinding].name) }}</span>
    </div>
    <ng-container *ngIf="getOptionById(segmentBinding); let option">
      <div class="selection-group flex flex-row flex-wrap">
        <div class="selection flex-none" *ngFor="let value of option.groupedOptions.noCategory; let j = index">
          <input
            id="{{ option.name }}-{{ j }}"
            [name]="option.name"
            type="radio"
            [value]="value"
            (ngModelChange)="onChange(option, -1, value)"
            [(ngModel)]="optionsSelected[option.id]"
          />
          <div
            *ngIf="!option.imgPath"
            class="selector color"
            (click)="clickInput(option.name + '-' + j, 0 - 1)"
            #colorTooltip1="tooltip"
            [tooltip]="utils.getColorName(value.name)"
          >
            <div [ngStyle]="{ background: getColor(value), 'border-radius': '5px' }" class="h-full w-full"></div>
          </div>
          <div
            *ngIf="option.imgPath"
            class="selector img"
            (click)="clickInput(option.name + '-' + j, 0 - 1)"
            #valueTooltip1="tooltip"
            [tooltip]="value.name"
          >
            <img [src]="option.imgPath + value.id + '.png'" />
          </div>
        </div>
      </div>

      <div *ngFor="let category of option.groupedOptions.groupedByCategory | keyvalue: originalOrder; let iCat = index">
        <h3 class="categoryTitle">{{ getCategoryText(category.key) }}</h3>

        <div class="selection-group flex flex-row flex-wrap">
          <div class="selection flex-none" *ngFor="let value of category.value; let j = index">
            <input
              id="{{ option.name }}-{{ getGlobalIndex(j, option, iCat) }}"
              [name]="option.name"
              type="radio"
              [value]="value"
              (ngModelChange)="onChange(option, -1, value)"
              [(ngModel)]="optionsSelected[option.id]"
            />
            <div
              *ngIf="!option.imgPath"
              class="selector color"
              (click)="clickInput(option.name + '-' + getGlobalIndex(j, option, iCat), 0 - 1)"
              #colorTooltip2="tooltip"
              [tooltip]="utils.getColorName(value.name)"
            >
              <div [ngStyle]="{ background: getColor(value), 'border-radius': '5px' }" class="h-full w-full"></div>
            </div>
            <div
              *ngIf="option.imgPath"
              class="selector img"
              (click)="clickInput(option.name + '-' + getGlobalIndex(j, option, iCat), 0 - 1)"
              #valueTooltip2="tooltip"
              [tooltip]="value.name"
            >
              <img [src]="option.imgPath + value.id + '.png'" />
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
